import { render, staticRenderFns } from "./queryOpmPerfReportList.vue?vue&type=template&id=32fbc150"
import script from "./queryOpmPerfReportList.vue?vue&type=script&lang=js"
export * from "./queryOpmPerfReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports